import actionSubOrderItem from '../../../../../Services/actionSubOrder'

export default (guid) => (dispatch) => {

  dispatch(actionSubOrderItem(guid, 'add'))

}
